/* Qapary · "Arma tu pijama": talla, estilo, estampado y upsell, solo con lo que hay en stock. */
(function () {
  const raiz = document.querySelector('[data-armador]');
  if (!raiz) return;
  const q = (s, r = raiz) => r.querySelector(s);
  const qa = (s, r = raiz) => Array.from(r.querySelectorAll(s));
  let productos = [];
  try { productos = JSON.parse(q('[data-armador-datos]').textContent); } catch (e) { productos = []; }

  const ORDEN = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '6Y', '8Y', '10Y', '12Y', '14Y', '16Y'];
  const ESTILOS = {
    largo: { nombre: 'Largo', texto: 'Pijama con pantalón' },
    corto: { nombre: 'Corto', texto: 'Pijama con short' },
    casa: { nombre: 'Para estar en casa', texto: 'Conjuntos, tops y pantalones' },
    camison: { nombre: 'Camisón o vestido', texto: 'Una sola pieza' },
    bata: { nombre: 'Bata', texto: 'Para encima' },
  };
  const PASOS = ['talla', 'estilo', 'estampado', 'upsell'];
  const soles = (c) => (window.qapary && window.qapary.money ? window.qapary.money(c) : 'S/ ' + (c / 100).toFixed(2));
  const esc = (t) => String(t).replace(/[&<>"]/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]));
  const estado = { talla: '', estilo: '', producto: null, extras: new Set(), paso: 0 };

  const enTalla = (p, z) => p.v.some((v) => v.z === z);
  const nombreTalla = (z) => (/^\d+Y$/.test(z) ? z.replace('Y', ' años') : z);
  const variante = (p, z) => p.v.find((v) => v.z === z);
  const publicar = (nombre, datos) => { try { window.Shopify && Shopify.analytics && Shopify.analytics.publish(nombre, datos); } catch (e) { /* sin analítica no se frena la compra */ } };

  const barra = q('[data-armador-barra]');
  const pasoDe = q('[data-armador-paso-de]');
  const eleccion = q('[data-armador-eleccion]');
  const seguir = q('[data-armador-seguir]');
  const atras = q('[data-armador-atras]');

  /* Un grupo de opciones que se comporta como radio: flechas para moverse, Enter o espacio para elegir. */
  function opcion(clase, html, elegida, deshabilitada, alElegir) {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'armador__opcion ' + clase; b.setAttribute('role', 'radio');
    b.setAttribute('aria-checked', elegida ? 'true' : 'false'); b.tabIndex = elegida ? 0 : -1;
    b.innerHTML = html; b.disabled = !!deshabilitada;
    b.addEventListener('click', alElegir);
    return b;
  }
  function radios(contenedor) {
    const bs = qa('.armador__opcion:not([disabled])', contenedor);
    if (bs.length && !bs.some((b) => b.tabIndex === 0)) bs[0].tabIndex = 0;
    contenedor.onkeydown = (e) => {
      const i = bs.indexOf(document.activeElement); if (i < 0) return;
      const paso = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if (!paso) return;
      e.preventDefault(); const j = (i + paso + bs.length) % bs.length;
      bs.forEach((b) => { b.tabIndex = -1; }); bs[j].tabIndex = 0; bs[j].focus();
    };
  }

  function pintarTallas() {
    const caja = q('[data-armador-tallas]'); caja.innerHTML = '';
    const tallas = ORDEN.filter((z) => productos.some((p) => enTalla(p, z)));
    /* Las tallas por edad (8Y, 12Y...) van en su propio grupo y se leen "8 años". */
    const esEdad = (z) => /^\d+Y$/.test(z);
    const boton = (z) => {
      const n = productos.filter((p) => enTalla(p, z)).length;
      const nombre = esEdad(z) ? z.replace('Y', '') + '<span class="armador__talla-unidad"> años</span>' : z;
      return opcion('armador__talla-opcion', '<span class="armador__talla">' + nombre + '</span><span class="armador__conteo">' + n + (n === 1 ? ' pijama' : ' pijamas') + '</span>', estado.talla === z, n === 0, () => {
        estado.talla = z; if (estado.estilo && !productos.some((p) => p.e === estado.estilo && enTalla(p, z))) estado.estilo = '';
        estado.producto = null; estado.extras.clear(); publicar('armador_talla', { talla: z }); pintar(); avanzarSolo();
      });
    };
    tallas.filter((z) => !esEdad(z)).forEach((z) => caja.append(boton(z)));
    const edades = tallas.filter(esEdad);
    if (edades.length) {
      const t = document.createElement('p');
      t.className = 'etiqueta armador__subgrupo'; t.textContent = 'Niñas y teens';
      caja.append(t);
      edades.forEach((z) => caja.append(boton(z)));
    }
    radios(caja);
  }

  function pintarEstilos() {
    const caja = q('[data-armador-estilos]'); caja.innerHTML = '';
    /* Estilo que vino del anuncio sin talla: se marca recién ahora, si hay stock en la talla elegida. */
    if (estado.estiloPendiente) {
      if (productos.some((p) => p.e === estado.estiloPendiente && enTalla(p, estado.talla))) estado.estilo = estado.estiloPendiente;
      estado.estiloPendiente = '';
    }
    Object.keys(ESTILOS).forEach((e) => {
      const lista = productos.filter((p) => p.e === e && enTalla(p, estado.talla));
      if (!lista.length) return;
      const foto = lista[0].f;
      caja.append(opcion('armador__estilo', '<img src="' + esc(foto) + '" alt="" loading="lazy" width="360" height="450"><span class="armador__estilo-texto"><span class="armador__estilo-nombre">' + ESTILOS[e].nombre + '</span><span class="armador__conteo">' + ESTILOS[e].texto + ' · ' + lista.length + ' en tu talla</span></span>', estado.estilo === e, false, () => {
        estado.estilo = e; estado.producto = null; estado.extras.clear(); publicar('armador_estilo', { talla: estado.talla, estilo: e }); pintar(); avanzarSolo();
      }));
    });
    radios(caja);
  }

  function pintarEstampados() {
    const caja = q('[data-armador-estampados]'); caja.innerHTML = '';
    const lista = productos.filter((p) => p.e === estado.estilo && enTalla(p, estado.talla));
    q('[data-armador-nota-estampado]').textContent = lista.length + (lista.length === 1 ? ' estampado' : ' estampados') + ' en talla ' + nombreTalla(estado.talla) + '. Toca uno para verlo puesto.';
    lista.forEach((p) => {
      const antes = p.a > p.p ? '<span class="precio--ancla"><span class="visualmente-oculto">Antes </span>' + soles(p.a) + '</span>' : '';
      caja.append(opcion('armador__estampado', '<span class="armador__tela"><img src="' + esc(p.f) + '" alt="" loading="lazy" width="360" height="360"><img src="' + esc(p.f) + '" alt="" loading="lazy" width="360" height="360"></span><span class="armador__estampado-texto"><span class="armador__estampado-nombre">' + esc(p.t) + '</span><span class="precio">' + soles(p.p) + '</span>' + antes + '</span>', estado.producto === p, false, () => {
        estado.producto = p; estado.extras.clear(); publicar('armador_estampado', { talla: estado.talla, estilo: estado.estilo, producto: p.h }); pintar();
      }));
    });
    radios(caja);
  }

  function pintarUpsell() {
    const p = estado.producto; if (!p) return;
    q('[data-armador-resumen]').innerHTML = '<img src="' + esc(p.f2 || p.f) + '" alt="' + esc(p.t) + '" width="240" height="320"><div><p class="armador__resumen-nombre">' + esc(p.t) + '</p><p class="armador__resumen-dato">Talla ' + nombreTalla(estado.talla) + ' · ' + ESTILOS[p.e].nombre + '</p><p class="precio">' + soles(p.p) + '</p><a class="pequeno enlace" href="' + esc(p.u) + '?variant=' + variante(p, estado.talla).id + '">Ver todas las fotos</a></div>';
    const caja = q('[data-armador-upsell]'); if (!caja) return;
    caja.innerHTML = '';
    /* Primero del mismo estilo y después del resto, siempre en la talla elegida. */
    const otros = productos.filter((x) => x !== p && enTalla(x, estado.talla)).sort((a, b) => (a.e === p.e ? 0 : 1) - (b.e === p.e ? 0 : 1)).slice(0, 3);
    caja.closest('.armador__paso').querySelector('.armador__upsell-titulo').hidden = !otros.length;
    otros.forEach((x) => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'armador__opcion armador__sugerencia';
      b.setAttribute('aria-pressed', estado.extras.has(x) ? 'true' : 'false');
      const pintarB = () => { const si = estado.extras.has(x); b.setAttribute('aria-pressed', si ? 'true' : 'false'); b.querySelector('.armador__sugerencia-accion').textContent = si ? 'Agregada' : 'Agregar'; };
      b.innerHTML = '<img src="' + esc(x.f) + '" alt="" loading="lazy" width="240" height="320"><span class="armador__sugerencia-texto"><span>' + esc(x.t) + '</span><span class="precio">' + soles(x.p) + '</span><span class="armador__sugerencia-accion"></span></span>';
      b.addEventListener('click', () => { if (estado.extras.has(x)) estado.extras.delete(x); else estado.extras.add(x); pintarB(); pintarBarra(); });
      caja.append(b); pintarB();
    });
  }

  function total() {
    let t = estado.producto ? estado.producto.p : 0;
    estado.extras.forEach((x) => { t += x.p; });
    return t;
  }

  function pintarBarra() {
    const partes = [estado.talla && 'Talla ' + nombreTalla(estado.talla), estado.estilo && ESTILOS[estado.estilo].nombre, estado.producto && estado.producto.t].filter(Boolean);
    eleccion.textContent = partes.join(' · ');
    const nombre = PASOS[estado.paso];
    const listo = (nombre === 'talla' && estado.talla) || (nombre === 'estilo' && estado.estilo) || (nombre === 'estampado' && estado.producto) || nombre === 'upsell';
    seguir.disabled = !listo;
    seguir.textContent = nombre === 'upsell' ? 'Añadir al carrito · ' + soles(total()) : 'Siguiente';
    atras.hidden = estado.paso === 0;
    barra.style.width = ((estado.paso + 1) / PASOS.length * 100) + '%';
    pasoDe.textContent = 'Paso ' + (estado.paso + 1) + ' de ' + PASOS.length;
  }

  function pintar() {
    PASOS.forEach((n, i) => { q('[data-paso="' + n + '"]').hidden = i !== estado.paso; });
    const n = PASOS[estado.paso];
    if (n === 'talla') pintarTallas();
    if (n === 'estilo') pintarEstilos();
    if (n === 'estampado') pintarEstampados();
    if (n === 'upsell') pintarUpsell();
    pintarBarra();
  }

  function ir(i, enfocar = true) {
    estado.paso = Math.max(0, Math.min(PASOS.length - 1, i));
    pintar();
    const paso = q('[data-paso="' + PASOS[estado.paso] + '"]');
    raiz.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    if (enfocar) q('.armador__pregunta', paso).focus({ preventScroll: true });
  }
  /* Talla y estilo avanzan solos tras elegir: el recorrido son cuatro toques. */
  function avanzarSolo() { setTimeout(() => { if (!seguir.disabled) ir(estado.paso + 1); }, 220); }

  atras.addEventListener('click', () => ir(estado.paso - 1));
  seguir.addEventListener('click', async () => {
    if (PASOS[estado.paso] !== 'upsell') { ir(estado.paso + 1); return; }
    await agregar();
  });

  const regalo = q('[data-armador-regalo]');
  const dedicatoria = q('[data-armador-dedicatoria]');
  regalo.addEventListener('change', () => { dedicatoria.hidden = !regalo.checked; if (regalo.checked) q('[data-armador-dedicatoria-texto]').focus(); });

  async function agregar() {
    const p = estado.producto; if (!p) return;
    const c = window.qapary && window.qapary.carrito;
    seguir.classList.add('boton--cargando'); seguir.disabled = true;
    try {
      const items = [p].concat(Array.from(estado.extras)).map((x, i) => ({ id: variante(x, estado.talla).id, quantity: 1, properties: { _origen: i === 0 ? 'armador' : 'armador_upsell' } }));
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: 'cart-drawer' }) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'No se pudo agregar');
      if (regalo.checked) {
        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Es un regalo': 'Sí', 'Dedicatoria': q('[data-armador-dedicatoria-texto]').value.trim() } }) });
      }
      publicar('armador_agregar', { talla: estado.talla, estilo: estado.estilo, producto: p.h, extras: estado.extras.size, regalo: regalo.checked });
      if (c && data.sections && data.sections['cart-drawer']) {
        if (regalo.checked && c.refrescar) await c.refrescar(); else c.reemplazar(data.sections['cart-drawer']);
        window.qapary.paneles.abrir('carrito', seguir);
      } else {
        location.href = '/cart';
      }
    } catch (e) {
      if (window.qapary && window.qapary.toast) window.qapary.toast(e.message, { tono: 'error' }); else alert(e.message);
    } finally {
      seguir.classList.remove('boton--cargando'); pintarBarra();
    }
  }

  /* Atajos desde el anuncio: ?talla=M&estilo=corto&regalo=1. Se respetan solo si hay stock. */
  const par = new URLSearchParams(location.search);
  const zPar = (par.get('talla') || '').toUpperCase();
  const ePar = (par.get('estilo') || '').toLowerCase();
  if (zPar && productos.some((p) => enTalla(p, zPar))) {
    estado.talla = zPar; estado.paso = 1;
    if (ePar && productos.some((p) => p.e === ePar && enTalla(p, zPar))) { estado.estilo = ePar; estado.paso = 2; }
  } else if (ePar && productos.some((p) => p.e === ePar)) {
    /* Con estilo y sin talla, la talla igual va primero; el estilo queda marcado para cuando llegue. */
    estado.estiloPendiente = ePar;
  }
  if (par.get('regalo') === '1') { regalo.checked = true; dedicatoria.hidden = false; }
  if (!productos.length) {
    q('[data-paso="talla"] .armador__pregunta').textContent = 'Estamos reponiendo stock';
    q('[data-armador-tallas]').innerHTML = '<p class="cuerpo">Ahora mismo no hay pijamas disponibles aquí. <a class="enlace" href="/pages/catalogo">Mira el catálogo</a>.</p>';
  }
  pintar();
})();
